"use strict";

// Добавляет в body атрибут scrolling, если есть прокрутка
// TODO: выяснить, где используется

import dom from "../dom";

function toggleScrolling(entries) {
    var entry = entries[0];
    document.body.toggleAttribute("scrolling", entry.intersectionRatio < 1);
}

dom.callAfterLoaded(() => {
    if (!("IntersectionObserver" in window)) {
        return;
    }
    var observer = new IntersectionObserver(toggleScrolling, { threshold: [1] });
    observer.observe(document.querySelector("#scroll-detector"));
});

export default {};
